import { useMemo } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { fontWeight, iconBtnType, IconButton, Icons, Text } from '../../../../../../packages';
import { Drawer, drawerType } from '../../../../../../packages/ui/organisms/drawer';
import { SymptomBottomCard } from '../symptom-card/SymptomBottomCard';
import { SymptomChart } from './symptom-chart';

// styles
import { useStyles } from './SymptomDetail.styles';

const SymptomDetail = ({ open, onClose, symptom, isNoDrawer, onClickNewReport, priorityType }) => {
  const classes = useStyles();

  const fullHistory = useMemo(() => {
    if (symptom) {
      const { history, priority, ...rest } = symptom;
      const current = { ...rest, priority, importanceLevel: priority };
      return history ? [current, ...history] : [current];
    }
    return [];
  }, [symptom]);

  // const [selectedTime, setSelectedTime] = useState(AppointmentsFilterDates[2]);

  // const times = AppointmentsFilterDates.map(time => ({
  //   ...time,
  //   onClick: () => setSelectedTime(time),
  // }));

  const renderContent = () => (
    <Box className={classes.container}>
      <Box className={clsx(classes.header, { [classes.headerNoDrawer]: isNoDrawer })}>
        <Box>
          <Text weight={fontWeight.BOLD} className={classes.headTitle}>
            All Reports - {symptom.name}
          </Text>
          <Text weight={fontWeight.BOLD} className={classes.headSubtitle}>
            {symptom.description}
          </Text>
        </Box>
        <IconButton icon="close" className={classes.closeBtn} onClick={onClose} />
      </Box>
      <Box className={clsx(classes.content, { [classes.contentNoDrawer]: isNoDrawer })}>
        {!isNoDrawer && (
          <Box className={classes.contentFilter}>
            <Text weight={fontWeight.BOLD} className={classes.contentTitle}>
              Importance level <Icons glyph="question-outlined" className={classes.question} />
            </Text>
            {/* <Menu icon="chevron-down" items={times} itemsWrapperClassName={classes.menuLabel}>
              <Text className={classes.menuLabel} level={textLevel.S}>
                {selectedTime.label}
              </Text>
            </Menu> */}
          </Box>
        )}
        <Box className={classes.contentChart}>
          <SymptomChart name={priorityType} items={fullHistory} />
        </Box>
        <Box>
          {fullHistory?.map((report, index) => (
            <Box key={index}>
              <SymptomBottomCard symptom={report} showBadge />
              {report.notes && <Text className={classes.contentDescription}>{report.notes}</Text>}
            </Box>
          ))}
        </Box>
      </Box>
      <Box className={classes.footer}>
        <IconButton variant={iconBtnType.TEXT} onClick={onClose}>
          Close
        </IconButton>
        <IconButton
          // icon="plus"
          onClick={onClickNewReport}
          className={classes.newReportBtn}
          variant={iconBtnType.PRIMARY}
        >
          Update report
        </IconButton>
      </Box>
    </Box>
  );

  if (isNoDrawer) {
    return <>{renderContent()}</>;
  }

  return (
    <Drawer open={open} onClose={onClose} variant={drawerType.NORMAL} className={classes.drawer}>
      {symptom && renderContent()}
    </Drawer>
  );
};

export { SymptomDetail };
